import cacheManager from "@/utils/cacheManager";

let PAG = null
// 缓存正在加载的 Promise
const loadingPromises = new Map()

const init = async () => {
  if (!PAG) {
    const PAGInit = window.libpag.PAGInit
    PAG = await PAGInit({
      locateFile: file => `${location.origin}/static/js/${file}`
    })
    return PAG
  } else {
    return PAG
  }
}

export const getPag = async url => {
  // 检查是否有缓存的 blob
  const value = await cacheManager.get(url);
  if (value) {
    return Promise.resolve(value)
  }

  // 检查是否正在加载
  if (loadingPromises.has(url)) {
    return loadingPromises.get(url)
  }

  // 没有缓存且没有正在加载，开始加载
  const loadPromise = fetch(url, { credentials: "same-origin" })
    .then(response => response.blob())
    .then(blob => {
      // 缓存 blob
      cacheManager.set(url, blob)
      // 移除加载状态
      loadingPromises.delete(url)
      return blob
    })

  // 缓存加载 Promise
  loadingPromises.set(url, loadPromise)
  return loadPromise
}

export const initPag = (id, url, autoPlay = true, options = {}) => {
  if (!url?.includes('pag')) {
    return
  }

  return init()
    .then(() => getPag(url)
      .then(blob => playPag(blob, id, url, autoPlay,  options)))
}

export const playPag = async (blob, id, url, autoPlay = true,  options) => {
  const file = new window.File([blob], url.replace(/(.*\/)*([^.]+)/i, '$2'))
  const pagFile = await PAG.PAGFile.load(file)
  const [canvas, canvasId] = createCanvas(id)
  const parentNode = canvas.parentNode

  // 使用抽离出来的函数计算缩放参数
  const [width, height] = calculateScaleAndSize(
    pagFile.width(),
    pagFile.height(),
    parentNode.offsetWidth,
    parentNode.offsetHeight
  )

  // 设置canvas尺寸为缩放后的尺寸
  canvas.width = width
  canvas.height = height

  const pagView = await PAG.PAGView.init(pagFile, `#${canvasId}`, {
    useScale: false,
    firstFrame: false,
    ...options
  })
  pagView.setRepeatCount(0)
  if (autoPlay){
    await pagView.play()
  }
  return pagView
}

export const createCanvas = (id) => {
  const e = document.getElementById(id)
  let canvas = e
  if (e.tagName !== 'CANVAS') {
    canvas = document.createElement('canvas')
    e.appendChild(canvas)
    id = id + '-canvas'
    canvas.id = id
  }
  return [canvas, id]
}

export const calculateScaleAndSize = (originalWidth, originalHeight, maxWidth, maxHeight) => {
  // 默认比例为1，尺寸为原始尺寸
  let scale = 1
  let width = originalWidth
  let height = originalHeight

  // 如果原始尺寸超过最大尺寸限制
  if (originalWidth > maxWidth || originalHeight > maxHeight) {
    // 计算宽度和高度的缩放比例
    const widthScale = maxWidth / originalWidth
    const heightScale = maxHeight / originalHeight

    // 选择较小的比例以确保两个维度都不超出限制
    scale = Math.min(widthScale, heightScale)

    // 计算缩放后的尺寸
    width = originalWidth * scale
    height = originalHeight * scale
  }

  return [width, height, scale]
}
